import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_ROUTE_PAYMENT_RESET = 'DELETE_ROUTE_PAYMENT_RESET';
export const DELETE_ROUTE_PAYMENT_LOADING = 'DELETE_ROUTE_PAYMENT_LOADING';
export const DELETE_ROUTE_PAYMENT_SUCCESS = 'DELETE_ROUTE_PAYMENT_SUCCESS';
export const DELETE_ROUTE_PAYMENT_REJECT = 'DELETE_ROUTE_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteRoutePaymentReset = () => ({ type: DELETE_ROUTE_PAYMENT_RESET });
export const deleteRoutePaymentLoading = () => ({ type: DELETE_ROUTE_PAYMENT_LOADING });
export const deleteRoutePaymentSuccess = (payload) => ({ type: DELETE_ROUTE_PAYMENT_SUCCESS, payload });
export const deleteRoutePaymentReject = (payload) => ({ type: DELETE_ROUTE_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteRoutePaymentRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/Route/web/DeleteRouteBilling?Id=${data.id}&IdRoute=${data.idRoute}`, options);
};
